/* Publish by EComposer at 2026-10-13 06:18:04*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-j72nc4hkhz7"]=  window.__ectimmers["ecom-j72nc4hkhz7"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-j72nc4hkhz7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j72nc4hkhz7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bn9esa2ushq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bn9esa2ushq', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}